import React from 'react';
import { Grid, Typography, Box, Button, Container } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import logo from '../Fxer.AI (7).png'; // Replace with the actual path to your logo image
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const LoginPage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        audience: "https://fxer.ai/api",
        scope: "read:all",
        redirectUri: `${window.location.origin}/welcome?action=login`,
      },
    });
  };

  const handleSignUp = () => {
    loginWithRedirect({
      authorizationParams: {
        audience: "https://fxer.ai/api",
        scope: "read:all",
        redirectUri: `${window.location.origin}/welcome?action=signup`,
      },
    });
  };

  return (
    <Container maxWidth={false} sx={{ minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 0 }}>
      <Grid 
        container 
        spacing={4} 
        alignItems="flex-start" 
        sx={{ 
          width: { xs: '100%', md: '80%' }, 
          margin: 0, 
          paddingLeft: { xs: '0', md: '240px' },
          '& .MuiGrid-item': { 
            paddingLeft: '0 !important', 
            paddingRight: '0 !important', 
            margin: '0 !important' 
          }
        }}
      >
{/*         <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' }, padding: 0 }}>
          <Box component="img" src={logo} alt="Logo" sx={{ height: 100, marginBottom: 2 }} /> 
          <Typography variant="h5" sx={{ color: '#131E3A', marginBottom: 2 }}>
            Fix your household issues fast. <br/> You can do it!
          </Typography>
          <Typography variant="body1" sx={{ color: '#131E3A', marginBottom: 2 }}>
            Fxer is dedicated to making home repair simple, we take the guess work out of it, giving you the confidence to fix anything!
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            Our questions get to the answer.
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            No need to wait for a plumber.
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            Save money!
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            We will walk you through every step.
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            No Tools? No worries, we can help.
          </Typography>
        </Grid> */}
        <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' }, padding: 0 }}>
          <Box component="img" src={logo} alt="Logo" sx={{ height: 100, marginBottom: 2 }} /> 
          <Typography variant="h5" sx={{ color: '#131E3A', marginBottom: 2 }}>
            Unlock your home's potential
          </Typography>
          <Typography variant="body1" sx={{ color: '#131E3A', marginBottom: 2 }}>
            Fxer is dedicated to providing indepth insights into your property, whether you're buying, selling, or investing!
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            Quickly analyze inspections reports
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            Gain insight into your property that no one else has
          </Typography>
          <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
            <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
            Save money and gain confidence in your quotes
          </Typography>
        </Grid> 
        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 0 }}>
          <Box sx={{ width: '100%', textAlign: 'center', marginTop: { xs: 0, md: '20%' } }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginBottom: 2 }}
              onClick={handleLogin}
            >
              Login
            </Button>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={handleSignUp}
            >
              Sign Up
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LoginPage;
